import DescriptorT from '@r6digital/rapidstor-types/react/entities/Descriptor';
import paramMap from './unitListParamMap';

/**
 * Filters a list of descriptors based on URL search params and paramMap logic.
 *
 * @param sourceDescriptors - The list of descriptors to filter
 * @param searchParams - The useSearchParams object to use for filtering
 * @returns Filtered list of descriptors
 */
export function filterDescriptorsByParams(
  sourceDescriptors: DescriptorT[],
  searchParams: URLSearchParams,
): DescriptorT[] {
  if (!sourceDescriptors.length) return [];

  const filters: Array<{
    fields: string[];
    key: 'min' | 'max';
    value: number;
  }> = [];

  Object.entries(paramMap).forEach(([param, { fields, key }]) => {
    const val = searchParams.get(param);
    if (val !== null && val !== '' && !Number.isNaN(Number(val))) {
      filters.push({
        fields,
        key: key as 'min' | 'max',
        value: Number(val),
      });
    }
  });

  // No params → no filtering
  if (filters.length === 0) {
    return sourceDescriptors;
  }

  return sourceDescriptors.filter((descriptor) => {
    const unitTypes = Array.isArray(descriptor.unitTypes)
      ? descriptor.unitTypes
      : [];

    const matchingUnitTypes = unitTypes.filter((unitType) => filters.every(({ fields, key, value }) => {
        const candidates = fields
          .map((field) => {
            const fieldValue =
              (unitType as unknown as Record<string, unknown>)[field];
            return typeof fieldValue === 'number' ? fieldValue : undefined;
          })
          .filter((v): v is number => typeof v === 'number');

        if (candidates.length === 0) return false;

        if (key === 'min') {
          return candidates.some((v) => v >= value);
        }

        if (key === 'max') {
          return candidates.some((v) => v <= value);
        }

        return true;
      }));

    return matchingUnitTypes.length > 0;
  });
}
